module.exports = __webpack_public_path__ + "img/checklist-pana.9ebf6fb0.9ebf6fb0.png";